<template>
<div >
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class="container" v-if="!loading">
			
			<div class="card mt-2">
				<div class="card-body">

					<div class="page-header">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">GENERAL</li>
							<li class="breadcrumb-item active">Vehículos</li>
						</ol>
						<div class="title">
							<h1>Vehículos</h1>
						</div>
						<div class="cta">
							<button class="btn btn-sm btn-outline-secondary" @click="readCode" >INICIAR CONTROL</button>
						</div>
					</div>

					<div class="filters-box">
						<div class="filter">
							<label>BUSCAR</label>
							<input 
								type="text" 
								class="form-control" 
								placeholder="Buscar" 
								v-model="filters.search" 
								@keyup.enter="updateFilters($event)">
						</div>
						<div class="filter">
							<label>Estado</label>
							<select class="form-control" 
								v-model="filters.status" 
								@change="updateFilters($event)">
								<option value="">Todos</option>
								<option value="PRE_ADMITTED">Pre admitidos</option>
								<option value="ADMITTED">En depósito temporal</option>
								<option value="IN_CUSTOMS_DEPOSIT">En depósito fiscal</option>
								<option value="CUSTOMS_DISPATCH_PENDING">Pendientes de despachar</option>
								<option value="IN_NATIONAL_DEPOSIT">En depósito nacional</option>
								<option value="PRE_DELIVERY_PENDING">Pendientes de pre entregar</option>
								<option value="PRE_DELIVERY_DONE">Pre entregas realizada</option>
								<option value="DELIVERY_SCHEDULED">Entregas programadas</option>
								<option value="DELIVERED">Entregados</option>
							</select>           
						</div>
					</div>

					<table class="table ">
						<tr class="table-head">
							<td>Chasis</td>
							<td>Vehículo</td>
							<td>Cliente</td>
							<td>Ubicación</td>
							<td>Estado</td>
						</tr>
						
						<router-link tag="tr" v-for="item of list" :key="item.id" :to="`/cars/${item.id}`" >
							<td>{{item.chassis_number}}</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.brand.title}}</span>
									<span >{{item.model}}</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span class="text-primary">{{item.client.name}}</span>
									<span >{{item.client.business_name}}</span>
								</div>
							</td>
							<td>
								<div class="tc" v-if="item.parkingSlot">
									<span class="text-primary">{{item.parkingSlot.typeText}}</span>
									<span >{{item.parkingSlot.code}}</span>
								</div>
								<div class="tc" v-else>
									<span class="text-primary">En deposito temporal</span>
								</div>
							</td>
							<td>
								<div class="tc">
									<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									<span v-if="item.status=='ADMITTED'" style="margin-left: 15px;">{{item.joined_at | moment("DD-MM-YYYY")}}</span>
									<!-- <span v-if="item.delivery_scheduled_at" style="margin-left: 15px;">{{item.delivery_scheduled_at | moment("DD-MM-YYYY")}}</span> -->
								</div>
							</td>
						</router-link>
						
					</table>


					<div class="alert alert-info text-center" v-if="list.length==0" >No se han encontrado vehículos</div>
					
					<vue-ads-pagination v-if="pagination"
						:total-items="pagination.total"
						:max-visible-pages="2"
						:items-per-page="pagination.length"
						:page="pagination.page-1"
						@page-change="pageChange"					
					></vue-ads-pagination>

				</div>
			</div>

			
		</div>
	</div>
	<CarPreview ref="carPreview"></CarPreview>

	<ReadCode ref="readCode"></ReadCode>

</div>
</template>

<script>
import gql from 'graphql-tag'
import listMixins from '@/mixins/listMixins'

import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import CarPreview from '@/views/cars/CarPreview'
import ReadCode from '@/views/controls/ReadCode'

export default {
	name: 'cars',
	components:{
		Navbar,
		Loader,
		CarPreview,
		ReadCode
	},
	mixins:[listMixins],
	data () {
		return {
			list:[],
			loading: true,
		}
	},
	beforeMount(){
		this.filters = this.getValidUrlParams();
		this.load();
	},
	methods:{
		readCode(){
			this.$refs.readCode.open()
		},
		load(){
			this.$apollo.query({
				query: gql`query ($first: Int!, $page: Int, $search: String, $status: String) {
					cars(first: $first, page: $page, search: $search, status: $status) {
						paginatorInfo {
							count
							currentPage
							total
						}
						data {
							id
							client{
								name
								business_name
							}
							model
							brand{
								title
							}
							parkingSlot{
								code
								deposit{
									title
								}
							}
							motor_number
							chassis_number
							delivery_scheduled_at
							joined_at
							status
							statusText					
						}
					}
				}`,
				variables: {
					page: this.pagination.page,
					first: this.pagination.length,
					search: this.filters.search,
					status: this.filters.status,
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.list = data.data.cars.data;
				this.pagination.total = data.data.cars.paginatorInfo.total;
				this.loading = false
			});
		},
		openPreview(id){
			this.$refs.carPreview.open(id)
		},

	}
}


</script>

<style>

</style>
